import { Component, OnInit, OnDestroy, Injectable } from '@angular/core';
import { AfterViewInit } from '@angular/core';
import { EnpsComponent } from '@common/components/base/enps-component';
import { TimeoutQueue } from '@common/services/timeout-queue';
import { AuthService } from '@common/services/authentication/auth.service';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { DroppableEnpsComponent } from '@suite/common/components/base/droppable-enps-component';

@Component({
    template: ""
})
export class EnpsRouterComponent extends DroppableEnpsComponent implements AfterViewInit, OnDestroy {
    public authService: AuthService;

    constructor(timeoutQueue: TimeoutQueue, authService: AuthService, protected activatedRoute: ActivatedRoute) {
        super(timeoutQueue);
        this.authService = authService;
    }

    ngAfterViewInit() {
        super.createSubscription(this.activatedRoute.params, this.routeChanged.bind(this));       
        if (this.authService.shouldReload) {
            location.reload();
        }
    }

    protected routeChanged(params: any) { }
}
